import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Keep public pages renderable during local visual testing even when the
// developer has not created a .env file yet. Requests against these fallback
// values fail normally; production deployments must provide the real values.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);
export const supabase = createClient(
  supabaseUrl || 'http://127.0.0.1:54321',
  supabaseKey || 'local-development-anon-key'
);

// ─── Auth helpers ────────────────────────────────────────────────────────────
export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

// ─── Data helpers (replace local storage) ────────────────────────────────────
export async function dbGet(table) {
  const { data, error } = await supabase.from(table).select('*');
  if (error) throw error;
  return data;
}

export async function dbUpsert(table, row) {
  const { data, error } = await supabase.from(table).upsert(row).select();
  if (error) throw error;
  return data;
}

export async function dbDelete(table, id) {
  const { error } = await supabase.from(table).delete().eq('id', id);
  if (error) throw error;
}
